<template>
  <!-- Retorno de 27/10 (card 86akj8q08): plano de estudos vigente com etapas
       pendentes, em destaque na página inicial do aluno autônomo, como o
       formulário pendente e a campanha. Some quando não há o que fazer; não
       bloqueia nada. -->
  <div v-if="plans.length" class="spr-card" :style="{ borderColor: color }">
    <div class="spr-head">
      <v-icon size="22" :color="color">mdi-map-marker-path</v-icon>
      <div class="spr-title">
        {{ $tc("studyPlan.homeTitle", plans.length) }}
      </div>
    </div>

    <div class="spr-list">
      <div v-for="plan in plans" :key="plan.id" class="spr-item">
        <div class="spr-item__main">
          <span class="spr-item__name">{{ plan.name }}</span>
          <span class="spr-item__meta">
            {{
              $t("studyPlan.progressDone", {
                done: plan.progress.done,
                total: plan.progress.total,
              })
            }}
            ·
            <strong>{{ deadlineLabel(plan) }}</strong>
          </span>
        </div>
        <v-progress-linear
          :value="plan.progress.percent"
          :color="color"
          rounded
          height="6"
          class="spr-item__bar"
          :aria-label="
            $t('studyPlan.progressOf', {
              done: plan.progress.done,
              total: plan.progress.total,
            })
          "
        />
      </div>
    </div>

    <v-btn
      depressed
      rounded
      small
      dark
      class="mt-3"
      :color="color"
      @click="open"
    >
      {{ $t("studyPlan.homeOpen") }}
    </v-btn>
  </div>
</template>

<script>
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import { classThemes } from "@/shared/classThemes";

// Mesma fonte da página do plano: a API devolve o plano vigente já com as
// etapas. Quem não é aluno autônomo recebe lista vazia. Falha de rede esconde
// o card, nunca a página inicial.
export default {
  name: "StudyPlanReminderCard",

  data() {
    return { plans: [] };
  },

  computed: {
    // Rosa dos alunos (o roxo é a cor do professor).
    color() {
      return classThemes.customer.primary;
    },
  },

  async mounted() {
    try {
      const res = await pitchCustomerApi.getStudyPlans();
      const current = res?.data?.data?.current || [];
      this.plans = current.filter(
        (plan) => plan.progress && plan.progress.done < plan.progress.total
      );
    } catch (error) {
      this.plans = [];
    }
  },

  methods: {
    daysLeft(plan) {
      const [year, month, day] = String(plan.deadline || "")
        .slice(0, 10)
        .split("-")
        .map(Number);
      const now = new Date();
      const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.round((Date.UTC(year, month - 1, day) - today) / 86400000);
    },

    deadlineLabel(plan) {
      const left = this.daysLeft(plan);
      if (left <= 0) return this.$t("studyPlan.lastDay");
      if (left === 1) return this.$t("studyPlan.oneDayLeft");
      return this.$t("studyPlan.daysLeft", { n: left });
    },

    // Por caminho: o nome da rota do aluno e do professor se confundem.
    open() {
      this.$router.push("/connect/aluno/plano-de-estudos").catch(() => null);
    },
  },
};
</script>

<style scoped>
.spr-card {
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 2px solid;
  border-radius: 16px;
  background: var(--dk-surface, #fff);
}

.spr-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.spr-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--dk-ink, #2b2540);
}

.spr-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.spr-item {
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 43, 122, 0.08);
}

.spr-item__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.spr-item__name {
  font-weight: 700;
  color: var(--dk-ink, #2b2540);
}

.spr-item__meta {
  color: var(--dk-pink, #e8276f);
  font-size: 0.875rem;
}

.spr-item__bar {
  margin-top: 8px;
}
</style>
